import { Entity } from './entity.model';

export interface OptionSize extends Entity {
  size: string;
  order?: number;
  productId?: number; // Product
}
